var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "item m-b" }, [
    _c(
      "div",
      { staticClass: "b-r-lg p-sm font-bold border value", class: _vm.color },
      [_vm._v("\n        " + _vm._s(_vm.declaration.value) + "\n    ")]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "font-bold m-l" }, [
      _vm._v("\n        " + _vm._s(_vm.declaration.label) + "\n    "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }